import styled from "styled-components";

import backgroundImage from "../img/background.png";

const PLACEHOLDER_SVG = encodeURIComponent(
  `<svg fill="#FFFFFF" width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M16 15.503A5.041 5.041 0 1 0 16 5.42a5.041 5.041 0 0 0 0 10.083zm0 2.215c-6.703 0-11 3.699-11 5.5v3.363h22v-3.363c0-2.178-4.068-5.5-11-5.5z"/></svg>`
);
export const PLACEHOLDER = `data:image/svg+xml;utf8,${PLACEHOLDER_SVG}`;

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; 
  align-items: flex-start;
  gap: 6px;
  width: 100vw;
  height: 100vh;
  background: #0f172a;
  padding: 6px;
  box-sizing: border-box;
  background-image: url(${backgroundImage});
  background-size: cover; 
  background-position: center;
`;
export const Tile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
 // min-height: 100px;
 // min-width: 80px;
`;
export const PhotoWrapper = styled.div`
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;
  overflow: hidden;
  border-radius: 8px;
`;

export const Photo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const Name = styled.div`
  font-family: "Mark For MC Narrow W00 Book";
  font-size: ${(p) => p.fontSize}px;
  color: white;
  text-align: center;
  margin-top: 4px;
  width: ${(p) => p.size}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
